import React from 'react';

// mui
import { Button, Tooltip } from '@mui/material';

// icons
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';

function DiscardChangesButton({ disabled, onDiscard }) {
  const handleClick = () => {
    if (onDiscard) {
      onDiscard();
    } else {
      window.location.reload();
    }
  };

  return (
    <Tooltip title="Undo all changes since last save" placement="bottom">
      <span>
        <Button
          size="small"
          variant="outlined"
          color="error"
          startIcon={<UndoOutlinedIcon />}
          disabled={disabled}
          onClick={handleClick}
          sx={{
            borderColor: 'transparent',
            color: 'text.primary',
            '&:hover': {
              borderColor: 'error.main',
              color: 'error.main',
              backgroundColor: 'background.paper',
            },
          }}
        >
          Undo
        </Button>
      </span>
    </Tooltip>
  );
}

export default DiscardChangesButton;
